



























































































































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {CommonStatus} from "@/enums/status";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {SaleStore} from "@/modules/sale/store";
import {FormModel} from "ant-design-vue";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
import WardSelector from "@/modules/regions/WardSelector/index.vue";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import {EmployeeType} from "@/enums/type";
import InputCurrency from "@/shared/components/InputCurrency/index.vue";

const form = {
    id: "",
    customerName: "",
    address: "",
    countryId: 1,
    provinceId: undefined,
    districtId: undefined,
    wardId: undefined,
    contact: "",
    email: "",
    phoneNumber: "",
    competitors: "",
    businessLine: "",
    estimatedRevenue: undefined,
    quotationVersion: "",
    quotationDate: undefined,
    lastSupportDate: undefined,
    serviceRequest: "",
    customerResponse: "",
    employeeRowGuid: undefined,
    status: undefined
}
@Component({
    name: "SaleForm",
    components: {
        InputCurrency,
        EmployeeSelector, MillisecondDatePicker, WardSelector, DistrictSelector, ProvinceSelector}
})
export default class extends mixins(CommonMixin){
    @Prop() readonly id!: number;
    CommonStatus = CommonStatus;
    EmployeeType = EmployeeType;
    form = {...form};
    
    rules = {
        name: [{ required: true, message: "Nhập tên bài viết", trigger: "change" }],
        author: [{ required: true, message: "Nhập tên tác giả", trigger: "change" }],
        description: [{ required: true, message: "Nhập mô tả bài viết", trigger: "change" }],
        content: [{ required: true, message: "Nhập nội dung bài viết", trigger: "change" }],
        thumbnail: [{ required: true, message: "Ảnh đại diện bài viết", trigger: "change" }]
    }
    
    async created() {
        if (this.id) {
            try {
                const data = await SaleStore.singleSale(this.id);
                this.form = assignValueToForm(this.form, data);
            } catch (e) {
                this.$message.error({
                    content: `${e.response?.data?.message || "Đã có lỗi xảy ra"}`
                })
            }
        }
    }
    
    onSubmit() {
        (this.$refs.formSale as FormModel).validate(async (valid) => {
            if (!valid) return;
            try {
                this.id
                    ? await SaleStore.updateSale(this.form)
                    : await SaleStore.createSale(this.form);
                this.$notification.success({
                    message: "Thành công",
                    description: `${this.id ? 'Sửa' : 'Tạo'} thành công`
                });
                this.$router.push({name: "saleList"});
            } catch (e) {
                this.$message.error(`${e.response?.data?.message || `${this.id ? 'Sửa' : 'Tạo'} thất bại`}`)
            }
        })
    }
}
